// price-breakdown.component.ts
import { Component, Input, OnChanges } from '@angular/core';
import { Rate } from '@app/shared/models/rate.model';
import { formatServiceName } from '@app/shared/utilities/providers.helper';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-price-breakdown',
  templateUrl: './price-breakdown.component.html',
  standalone: false
})
export class PriceBreakdownComponent implements OnChanges {
  @Input() rate!: Rate; 
  applicableTaxes: any[] = [];
  applicableOptions: any[] = [];
  formatServiceName = formatServiceName;

  constructor(private translate: TranslateService) {} 

  ngOnChanges() {
    this.updateApplicableTaxes();
  }

  private updateApplicableTaxes() {
    if (this.rate && this.rate.taxes) {
      this.applicableTaxes = this.rate.taxes.filter(tax => tax.amount > 0);
    } else {
      this.applicableTaxes = [];
    }
  }

  getLabel(prefix: string, item: { code?: string; name: string }): string {
    if (!item.code) {
      return item.name;
    }
  
    const key = `${prefix}.${item.code}`;
    const translated = this.translate.instant(key);
  
    return translated === key ? item.name : translated;
  }

}